<template>
	<div class="editInfo">
		<back-to></back-to>
		<section class="editInfo-top">
			<div class="editInfo-top-con">
				<h2>基本信息</h2>
				<span>
					<van-field v-model="name" label="姓名" placeholder="与证件保持一致" />
					<van-field v-model="name_left" label="名(拼音)" placeholder="与证件保持一致" />
					<van-field v-model="name_right" label="名(拼音)" placeholder="与证件保持一致" />
					<van-field v-model="phone" label="电话" placeholder="请填写您的电话号码" />
				</span>
			</div>
			<div class="editInfo-top-con">
				<h2>证件信息</h2>
				<span>
					<van-field v-model="cardId" label="身份证" placeholder="请输入身份证信息" />
					<van-field v-model="passport" label="护照" placeholder="请输入护照信息" />
					<label for="" class="editInfo-top-con-sex">
						<span>性别</span>
						<span>
							<p :class="sexid == 1?'activeed':''" @click="sexid = 1">男士</p>
							<p :class="sexid == 2?'activeed':''" @click="sexid = 2">女士</p>
						</span>
					</label>
				</span>
			</div>
		</section>
		<section class="btned">
			<span @click="del">删除</span>
			<span @click="save">保存</span>
		</section>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		formatTime
	} from '@/config/util'
	import {
		Toast
	} from 'vant'
	export default {
		name: 'swimOrder',
		components: {
			BackTo
		},
		data() {
			return {
				phone: "",
				name: "",
				name_right: "",
				name_left: "",
				cardId: "",
				passport: "",
				index: "",
				sexid: 1
			}
		},
		created() {
			this.index = this.$route.query.index
			if (this.cruiseinfo.length > 0) {
				this.phone = this.cruiseinfo[this.index].phone
				this.name = this.cruiseinfo[this.index].name
				this.name_right = this.cruiseinfo[this.index].name_right
				this.name_left = this.cruiseinfo[this.index].name_left
				this.cardId = this.cruiseinfo[this.index].cardId
				this.passport = this.cruiseinfo[this.index].passport
				this.sexid = this.cruiseinfo[this.index].sexid
			}
		},
		mounted() {

		},
		computed: {
			...mapGetters('account', ['cruiseinfo'])
		},
		methods: {
			...mapMutations('account', ['setCruiseinfo']),
			save() {
				if (this.name == '') {
					Toast("请输入正确的姓名")
					return
				}
				if (this.phone == '') {
					Toast("请输入正确的电话")
					return
				}
				if (this.cardId == '') {
					Toast("请输入正确的身份证号")
					return
				}
				var buyNum = {
					phone: this.phone,
					name: this.name,
					name_right: this.name_right,
					name_left: this.name_left,
					cardId: this.cardId,
					passport: this.passport,
					sexid: this.sexid
				}
				if (this.cruiseinfo.length > 0) {
					var list = this.cruiseinfo
					list[this.index] = buyNum
				} else {
					var list = []
					for (let i = 0; i <= this.index; i++) {
						if (i = this.index) {
							list[i] = buyNum
						} else {
							list[i] = ""
						}

					}
				}
				this.setCruiseinfo(list)
				this.$router.back()
			},
			del(){
				this.setCruiseinfo([])
				this.$router.back()
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.editInfo-top-con h2 {
		width: 710px;
		height: 72px;
		position: relative;
		background: #F5F5F5;
		font-size: 26px;
		color: #999999;
		margin: 0 auto;
		line-height: 72px;
	}

	.editInfo-top-con-sex {
		position: relative;
		display: flex;
		box-sizing: border-box;
		width: 100%;
		padding: 2.666667vw 4.266667vw;
		overflow: hidden;
		color: #323233;
		font-size: 3.733333vw;
		line-height: 6.4vw;
		background-color: #fff;
	}

	.editInfo-top-con-sex span {
		display: flex;
		align-items: center;
		flex: none;
	}

	.editInfo-top-con-sex span:first-child {
		-webkit-box-flex: 0;
		flex: none;
		box-sizing: border-box;
		width: 6.2em;
		margin-right: 3.2vw;
		color: #646566;
		text-align: left;
		word-wrap: break-word;
	}

	.editInfo-top-con-sex p {
		margin-right: 80px;
		width: 100px;
		height: 50px;
		border: 2px solid #C1C1C1;
		border-radius: 3px;
		text-align: center;
		line-height: 50px;
	}

	.activeed {
		border: 2px solid #FF7A09 !important;
		color: #FF7A09;
	}
	
	.btned span:first-child {
		opacity: 1;
		border: 1px solid #CCCCCC;
		width: 340px;
		height: 80px;
		border-radius: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 99;
		bottom: 20px;
		left: 20px;
		font-size: 28px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #666666;
	}

	.btned span:last-child {
		width: 340px;
		height: 80px;
		background: #FF7A09;
		box-shadow: 0px 3px 10px 1px rgba(236, 224, 215, 0.6784313725490196);
		border-radius: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 99;
		bottom: 20px;
		right: 20px;
		font-size: 28px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
	}
</style>
